export const capitalize = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

export const getDateFormatted = ({
  date,
  locale = 'es-ES',
  options = { month: 'long', year: 'numeric' },
  lastDayOfYear = false,
}: {
  date: string | Date;
  locale?: string;
  options?: Intl.DateTimeFormatOptions;
  lastDayOfYear?: boolean;
}): string => {
  const formater = new Intl.DateTimeFormat(locale, {
    ...options,
    ...(lastDayOfYear ? { day: 'numeric' } : {}),
  });
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  if (lastDayOfYear) {
    const year = dateObj.getFullYear();
    const lastDay = new Date(year, 11, 31); // 11 es diciembre (0-11)
    const dateFormatted = formater.format(lastDay);
    return capitalize(dateFormatted);
  }

  const dateFormatted = formater.format(dateObj);
  return capitalize(dateFormatted);
};
